<ngb-tabset>
    <ngb-tab title="General">
        <ng-template ngbTabContent let-modal>
            <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title" *ngIf="!editar">Nueva dirección de envío</h4>
                <h4 class="modal-title" id="modal-basic-title" *ngIf="editar">Editar dirección de envío</h4>
            </div>
            <div class="modal-body px-4">
                <form action="" #form="ngForm" autocomplete="off">


                    <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                        <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Código:</label>
                        <input class="focus-input input_border form-control col-md-2 tsiInput" id="codEnvio"
                            name="DireccionTemp.codenv" [(ngModel)]="DireccionTemp.codenv" type="text"
                            style="margin-right: .5rem" disabled>
                        <span style="color: red; font: sans-serif; margin-left: -6px">(*)</span>

                        <app-custom-switch [(valor)]="checkActivo" [identificador]="'1'"
                            style="margin-left: -14px;"></app-custom-switch>
                    </div>

                    <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                        <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Descripción:</label>
                        <input class="focus-input input_border form-control col-md-8 tsiInput" id="desEnvio"
                            name="DireccionTemp.descri" [(ngModel)]="DireccionTemp.descri" maxlength="50" type="text"
                            tabindex="801">
                        <span style="color: red; font: sans-serif; margin-left: -6px">(*)</span>
                    </div>

                    <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                        <label class="col-md-2 text-left control-label col-form-label">Dirección:</label>
                        <input class="focus-input input_border form-control col-md-8 tsiInput" id="direccionE1"
                            name="DireccionTemp.direc1" [(ngModel)]="DireccionTemp.direc1" maxlength="120" type="text"
                            tabindex="802">

                        <span style="color: red; font: sans-serif; margin-left: -6px">(*)</span>
                    </div>

                    <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                        <label class="col-md-2 text-left control-label col-form-label">Referencia:</label>
                        <input class="focus-input input_border form-control col-md-4 tsiInput" id="referenciaEnvio"
                            name="DireccionTemp.direc2" [(ngModel)]="DireccionTemp.direc2" maxlength="50" type="text"
                            tabindex="803">
                    </div>

                    <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                        <label class="col-md-2 text-left control-label col-form-label">Código EAN:</label>
                        <input class="focus-input input_border form-control col-md-4 tsiInput" id="codEanEnvio"
                            name="DireccionTemp.codcen" [(ngModel)]="DireccionTemp.codcen" maxlength="30" type="text"
                            tabindex="805">
                    </div>

                    <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                        <label class="col-md-2 text-left control-label col-form-label">Teléfono:</label>
                        <input class="focus-input input_border form-control col-md-4 tsiInput"
                            name="DireccionTemp.telenv" [(ngModel)]="DireccionTemp.telenv" maxlength="30" type="text"
                            tabindex="804">
                    </div>

                    <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                        <label class="col-md-2 text-left control-label col-form-label">Celular:</label>
                        <input class="focus-input input_border form-control col-md-4 tsiInput" id="celularEnvio"
                            name="DireccionTemp.faxenv" [(ngModel)]="DireccionTemp.faxenv" maxlength="30" type="text"
                            tabindex="806">
                    </div>
                </form>

            </div>
            <div class="modal-footer">

                <button class="btn btn-rounded btn-info" type="button" (click)="nuevaDireccionEnvio()" *ngIf="!editar"
                    tabindex="607"><i class="fa fa-save"></i> Guardar</button>
                <button class="btn btn-rounded btn-info" type="button" (click)="_actualizar()" *ngIf="editar"
                    tabindex="608"> <i class="fa fa-save"></i> Guardar</button>


                <button type="button" class="btn btn-rounded btn-warning" (click)="_close()" tabindex="6"><i
                        class="fa fa-times-circle"></i> Cancelar</button>
            </div>
        </ng-template>
    </ngb-tab>


    <ngb-tab *ngIf="editar">
        <ng-template ngbTabTitle><b>Clases</b></ng-template>
        <ng-template ngbTabContent let-modal>

            <div class="modal-header">
                <div>
                    <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="nuevoClase()"><i
                            class="fa fa-plus"></i> Nuevo
                    </button>

                    <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="modificarUbigeo()"
                        [disabled]="btnUbigueoDisable"><i class="fa fa-plus"></i> Ubigeo
                    </button>
                </div>


                <!--<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                    <span aria-hidden="true">&times;</span>
                </button>-->
            </div>

            <div class="modal-body">
                <div class="table-responsive">
                    <table class="table table-sm table-striped table-bordered m-t-20 table-hover">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Clase</th>
                                <th scope="col">Descripción</th>
                                <th scope="col">Código</th>
                                <th scope="col">Descripción</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of DireccionTemp.clases">
                                <td scope="row" style="display: table-cell; text-align: center; padding-bottom: 0px;">
                                    <div class="btn-group btn-group-xs" role="group" style="margin: 0px;padding: 0px;">
                                        <button type="button" class="btn btn-sm"><span class="fas fa-pencil-alt"
                                                (click)="open2(content2 , item)" aria-hidden="true"></span></button>
                                        <button type="button" class="btn btn-sm "><span class="fas fa-trash-alt"
                                                (click)="EliminarClase(item)" aria-hidden="true"></span></button>
                                    </div>
                                </td>
                                <th scope="row">{{ item.clase }}</th>
                                <td scope="row">{{ item.desclase }}</td>
                                <td style="white-space: nowrap;">{{ item.codigo }}</td>
                                <td style="white-space: nowrap;">{{ item.descodigo }}</td>

                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>

            <div class="modal-footer">

                <button class="btn btn-rounded btn-info" type="button" (click)="nuevaDireccionEnvio()" *ngIf="!editar"
                    tabindex="607"><i class="fa fa-save"></i> Guardar</button>
                <button class="btn btn-rounded btn-info" type="button" (click)="_actualizar()" *ngIf="editar"
                    tabindex="608"><i class="fa fa-save"></i> Guardar</button>

                <button type="button" class="btn btn-rounded btn-warning" (click)="_close()" tabindex="6"><i
                        class="fa fa-times-circle"></i> Cancelar</button>


            </div>
        </ng-template>

        <ng-template #content2 let-modal1>
            <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">Modificar clase</h4>
                <button type="button" class="close" aria-label="Close" (click)="modal1.dismiss('Cross click')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body pl-4">
                <form>

                    <div class="form-group">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                                    <!---->
                                    <!---->
                                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Clase:</label>
                                    <div class="col-md-2">
                                        <input style="text-align: center;" class="form-control tsiInput"
                                            [(ngModel)]="editinputcla" name="editinputcla" type="text"
                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                            maxlength="3" disabled>
                                    </div>
                                    <div class="col-md-7">
                                        <select disabled tabindex="15" class="col-sm-12 focus-input input_border  select_border tsiSelect "
                                            style="color: black;" [(ngModel)]="editinputcla" name="editinputcla"
                                            #selectClase>
                                            <option *ngFor="let claseSele of listaclases" value="{{claseSele.codigo}}">
                                                {{claseSele.codigo+' - '+claseSele.descri}}
                                            </option>
                                        </select>
                                    </div>
                                    <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                                </div>
                                <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                                    <!---->
                                    <!---->
                                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Código:</label>
                                    <div class="col-md-2">
                                        <input disabled style="text-align: center;" class="form-control tsiInput"
                                            [(ngModel)]="editinputcodigo" name="editinputcodigo" type="text"
                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                            maxlength="3">
                                    </div>
                                    <div class="col-md-7">
                                        <select tabindex="15" class="col-sm-12 focus-input input_border  select_border tsiSelect "
                                            [(ngModel)]="editinputcodigo" name="editinputcodigo" #selectClase>
                                            <option *ngFor="let codigoSele of listacodigos"
                                                value="{{codigoSele.codigo}}">
                                                {{codigoSele.codigo+' - '+codigoSele.descri}}
                                            </option>
                                        </select>
                                    </div>
                                    <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </form>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-success" (click)="guardarActualizarClase();"
                    tabindex="5"><i class=" fas fa-angle-double-right"></i> Continuar</button>
                <button type="button" class="btn btn-rounded btn-warning" (click)="closeInsert()"
                    (click)="modal1.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                    Cancelar</button>

            </div>
        </ng-template>

    </ngb-tab>

</ngb-tabset>